import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { getCosmeticData } from "../../../utils/data/CosmeticData";
import NoPage from "../../../utils/NoPage";
import CosmeticDetailLeft from "./CosmeticDetailLeft";
import CosmeticDetailRight from "./CosmeticDetailRight";
import { CosmeticOwner } from "./CosmeticOwner";
import TradeHistory from "./TradeHistory";

export default function CosmeticDetail() {
  const { type, id } = useParams();
  const cosmeticData = getCosmeticData();

  if (!(type in cosmeticData && id in cosmeticData[type])) {
    return <NoPage />;
  }

  const item = cosmeticData[type][id];
  const obtainList = Array.isArray(item.obtain)
    ? item.obtain.join(", ")
    : "Unknown";
  const description = `Rarity: ${
    item.rarity
  } | Obtain via: ${obtainList} | Tradeable: ${item.isTradable ? "Yes" : "No"}`;
  const imageUrl = item.preview?.startsWith("/")
    ? `${window.location.origin}${item.preview}`
    : item.preview || "";

  return (
    <div>
      <Helmet>
        <title>
          {item.name} | {item.type}
        </title>
        <meta name="description" content={description} />
        <meta property="og:title" content={`${item.name} | ${item.type}`} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={imageUrl} />
        <meta
          property="twitter:title"
          content={`${item.name} | ${item.type}`}
        />
        <meta property="twitter:description" content={description} />
        <meta property="twitter:image" content={imageUrl} />
      </Helmet>
      <div className="page_container">
        <br />
        <br />
        <div className="w-layout-grid grid-title">
          <div className="zeqa--subtitle">{item.type}</div>
          <h1 className="large-heading">{item.name}</h1> <br />
        </div>
        <br></br>
        <div className="cosmetic_container cosmetic_detail_container">
          <CosmeticDetailLeft item={item} /> <CosmeticDetailRight item={item} />
        </div>
        <br></br>
        <br></br>
        <div className="cosmetic_container">
          <CosmeticOwner type={type} id={id} />
        </div>
        <br></br>
        <br />
        <div className="cosmetic_container">
          <TradeHistory type={type} id={id} />
        </div>
        <br></br>
        <br></br>
        <br></br>
      </div>{" "}
    </div>
  );
}
